import { render, staticRenderFns } from "./RoiStats.vue?vue&type=template&id=42f6ac9c"
import script from "./RoiStats.vue?vue&type=script&lang=js"
export * from "./RoiStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports